import React from "react";
import FooterOne from "../components/Footer/FooterOne";
import FooterTwo from "../components/Footer/FooterTwo";
import FooterThree from "../components/Footer/FooterThree";
import HeaderOne from "../components/Header/HeaderOne";
import PageLoader from "../components/PageLoader/PageLoader";
import cn from "classnames";

const LayoutOne = (props) => {
  return (
    <div className={cn("")}>
      <PageLoader />

      <HeaderOne />

      {props.children}

      <FooterOne />
      {/* <FooterThree /> */}
    </div>
  );
};

export default LayoutOne;
